[
  {
    "difference": {
      "unit": "minutes",
      "start": 0,
      "end": 2
    },
    "result": {
      "unit": "seconds",
      "amount": 1
    }
  },
  {
    "difference": {
      "unit": "minutes",
      "start": 2,
      "end": 5
    },
    "result": {
      "unit": "seconds",
      "amount": 10
    }
  },
  {
    "difference": {
      "unit": "minutes",
      "start": 5,
      "end": 30
    },
    "result": {
      "unit": "seconds",
      "amount": 30
    }
  },
  {
    "difference": {
      "unit": "minutes",
      "start": 30,
      "end": 120
    },
    "result": {
      "unit": "minutes",
      "amount": 2
    }
  },
  {
    "difference": {
      "unit": "hours",
      "start": 2,
      "end": 24
    },
    "result": {
      "unit": "minutes",
      "amount": 10
    }
  },
  {
    "difference": {
      "unit": "days",
      "start": 1,
      "end": 7
    },
    "result": {
      "unit": "hours",
      "amount": 1
    }
  },
  {
    "difference": {
      "unit": "days",
      "start": 7,
      "end": 31
    },
    "result": {
      "unit": "hours",
      "amount": 12
    }
  },
  {
    "difference": {
      "unit": "months",
      "start": 1,
      "end": 12
    },
    "result": {
      "unit": "days",
      "amount": 2
    }
  }
]
